/* eslint no-console: 0 */
import store from './store'
import utils from './utils'

export default {
  log(...args) {
    if (store.getters.config.debug) {
      console.log(...args)
    }
  },
  event(...args) {
    this.log(`%c[D2C] ${args.splice(0, 1)}`, `font-weight: bold; color: #099`, ...args)
  },
  fail(...args) {
    this.log(`%c[D2C] ${args.splice(0, 1)}`, `font-weight: bold; color: #f00`, ...args)
  },
  info(...args) {
    this.log(`%c[D2C] ${args.splice(0, 1)}`, `font-weight: bold; color: #06c`, ...args)
  },
  success(...args) {
    this.log(`%c[D2C] ${args.splice(0, 1)}`, `font-weight: bold; color: #090`, ...args)
  },
  verbose(...args) {
    this.log(`%c[D2C] ${args.splice(0, 1)}`, `font-weight: bold; color: #ccc`, ...args)
  },
  warning(...args) {
    this.log(`%c[D2C] ${args.splice(0, 1)}`, `font-weight: bold; color: #c60`, ...args)
  },
  trace() {
    if (store.getters.config.debug) {
      console.groupCollapsed('%c[D2C] 🔍 Tracing', `font-weight: bold; color: #999`)
      console.trace()
      console.groupEnd()
    }
  },
  diff(object, newProps) {
    if (store.getters.config.debug) {
      const target = `${object.target || newProps.target} ${object.name}`
      const diff = utils.getDiff(object, newProps)
      const diffCount = Object.keys(diff).length
      if (diffCount) {
        console.groupCollapsed(`[D2C] 🔨 Updating of ${target} (${diffCount} keys have changed)`)
        for (const key in diff) {
          console.log(`%c${key}: %c${diff[key][0]}%c >> %c${diff[key][1]}`, 'font-weight: bold', 'color: #c00', 'font-weight: bold', 'color: #090')
        }
      } else {
        console.groupCollapsed(`[D2C] 🔨 Updating of ${target} (no changes)`)
      }
      this.trace()
      console.groupEnd()
    }
  },
  notify(notification) {
    this.warning('A notification should be shown', notification)
  },
  closeAllNotifications() {
    this.warning('All notifications should be closed')
  },
}
